import {Injectable} from '@angular/core';
import * as Crypto from 'crypto-js';

@Injectable()
export class CryptoService {

  constructor() {}


  public sha256(arg: any): string {
    let str: string;
    if (arg instanceof Object) {
      str = JSON.stringify(arg);
    } else {
      str = arg.toString();
    }
    return Crypto.SHA256(str).toString();
  }

  public aesEncrypt(value: string, key: string): string {
    return Crypto.AES.encrypt(value, key).toString();
  }

  public aesDecrypt(value: string, key: string): string {
    return Crypto.AES.decrypt(value, key).toString(Crypto.enc.Utf8);
  }

  public makeKey(pass: string, salt: string): string {
    let ret = pass;
    for (let i = 0; i < 20; i++) {
      ret = this.sha256(pass + salt);
    }
    return ret;
  }


  public sha384(arg: any) {
    let str: string;
    if (arg instanceof Object) {
      str = JSON.stringify(arg);
    } else {
      str = arg;
    }
    return Crypto.SHA384(str).toString();
  }

  public randKey(digit: number) {
    if (!digit) {
        digit = 10;
    }

    const buffer = 'abcdefghijklmnopqrstuvwxyz0123456789';

    let ret = '';
    for (let i = 0; i < digit; i++) {
        const date = new Date();
        const seed = Math.round(date.getTime() / Math.random()) % (buffer.length - 1);
        ret += buffer[seed];
    }

    return ret;
  }

  public formatMaskByPostionEnd(str, chr, remainPosition, width) {
    if (str) {
      str = str.trim();
      var temp = "";
      temp = str.substring(0, str.length - remainPosition - width);
      for (var i = 0; i < width; i++) {
        temp = temp + chr;
      }
      temp += str.charAt(str.length - 1);
      return temp;
    } else {
      return str;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/service/crypto.service.ts